const routes = {
  getVehicleBookingFilter: 'vehicleBookings/filters',
  getVehicleBookings: 'vehicleBookings',
    getVehicleBookings2: 'vehicleBookings/customers',
  getVehicleBookingDetail: 'vehicleBookings/details',
  createVehicleBooking: 'vehicleBookings/add',
  updateVehicleBooking: 'vehicleBookings/edit',
  getMissingFields: 'vehicleBookings/missingValues',
  updateMissingFieldVehicleBooking: 'vehicleBookings/update',
  getApprovalList: 'vehicleBookings/approvals',
  getApprovalDetail: 'vehicleBookings/approvals/details',
  reviewApproval: 'vehicleBookings/approvals/review',
  getBookingCustomers: 'vehicleBookings/filters',
  getVinDetail:'vehicleBookings/completeDetails',
  getTaxation:'vehicleBookings/taxations',
  getMasterReport:'vehicleBookings/masterReport',
  deleteVehicle:"vehicleBookings/delete",
  updateBookingStatus:'vehicleBookings/statuses/add',
  getTimeline:'vehicleBookings/statuses',
  deleteBooking:'vehicleBookings/delete'

};

export default routes